namespace GeniuzPOS.ReportMasterData {
    export interface Report_1302Form {
    }

    export class Report_1302Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1302';
    }
}
